import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';

import './ProductCatalogHierarchyView.scss';

class ProductCatalogHierarchyView extends Component {
  static propTypes = {
    catalog: PropTypes.object.isRequired,
    setActiveFilters: PropTypes.func.isRequired,
    activeFilters: PropTypes.shape({
      department: PropTypes.object,
      category: PropTypes.object,
      tag: PropTypes.object,
      brand: PropTypes.string,
      AllBrand_id: PropTypes.number
    })
  };

  state = {
    searchVal: '',
    displayingBrands: false
  };

  toggleIndustry = industry => {
    const turningOff = industry.id === _.get(this.props, 'activeFilters.industry.id') && !this.props.activeFilters.department;
    this.props.setActiveFilters({
      industry: turningOff ? null : industry,
      department: null,
      category: null,
      tag: null,
      AllBrand_id: null
    });
  };

  toggleDepartment = department => {
    const turningOff = department.id === _.get(this.props, 'activeFilters.department.id') && !this.props.activeFilters.category;
    this.props.setActiveFilters({
      department: turningOff ? null : department,
      category: null,
      tag: null,
      AllBrand_id: null
    });
  };

  toggleCategory = category => {
    const turningOff = category.id === _.get(this.props, 'activeFilters.category.id');
    this.props.setActiveFilters({
      category: turningOff ? null : category,
      tag: null,
      AllBrand_id: null
    });
  };

  toggleTag = (tag, category) => {
    const turningOff = tag.id === _.get(this.props, 'activeFilters.tag.id');
    this.props.setActiveFilters({
      tag: turningOff ? null : tag,
      AllBrand_id: null,
      category
    });
  };

  toggleBrand = (brand, category) => {
    const turningOff = brand.id === _.get(this.props, 'activeFilters.AllBrand_id');
    this.props.setActiveFilters({
      tag: null,
      AllBrand_id: turningOff ? null : brand.id,
      category
    });
  };

  render() {
    const { catalog, activeFilters } = this.props;
    const { searchVal, displayingBrands } = this.state;
    const { industries } = catalog;
    const activeDepartment = activeFilters.department;
    const activeCategory = activeFilters.category;
    const activeTag = activeFilters.tag;
    const activeAllBrand_id = activeFilters.AllBrand_id;
    const isSearching = !!searchVal.length;
    const allBrands = _.get(catalog, 'brands') ?? [];
    return (
      <div className='product-catalog-hierarchy-view-outer-container panel'>
        <input
          className='search-input'
          placeholder='Search For Category or Brand'
          value={searchVal}
          onChange={({ target }) => this.setState({ searchVal: target.value })}
        />
        {industries &&
          _.orderBy(industries, 'name').map(industry => {
            const { name, id } = industry;
            const departments = industry.departments.filter(department => department.categories.length);
            const active = activeFilters.industry?.id === industry.id;
            const visible = !isSearching || (name && name.toLowerCase().includes(searchVal.toLowerCase()));
            if (!departments.length) return null;
            return (
              <div key={id}>
                {visible && (
                  <div onClick={() => this.toggleIndustry(industry)} className={classnames('row', { active: active })}>
                    <div className='main'>
                      {name} ({departments.length})
                    </div>
                  </div>
                )}
                {departments &&
                  (active || isSearching) &&
                  _.orderBy(departments, 'name').map(department => {
                    const { name, id, categories } = department;
                    const active = activeDepartment && activeDepartment.id === id;
                    const visible = !isSearching || name.toLowerCase().includes(searchVal.toLowerCase());
                    if (!categories.length) return null;
                    return (
                      <Fragment key={id}>
                        {visible && (
                          <div onClick={() => this.toggleDepartment(department)} className={classnames('row level-two', { active: active })}>
                            <div className='main'>
                              {name} ({categories.length})
                            </div>
                          </div>
                        )}
                        {(active || isSearching) &&
                          _.orderBy(categories, 'name').map(category => {
                            const { name, id, tags } = category;
                            const isCategoryActive = activeCategory && activeCategory.id === id;
                            const visible = !isSearching || name.toLowerCase().includes(searchVal.toLowerCase());
                            return (
                              <Fragment key={id}>
                                {visible && (
                                  <div
                                    onClick={() => this.toggleCategory(category)}
                                    className={classnames('row level-three', { active: isCategoryActive })}
                                  >
                                    <div className='main'>{name}</div>
                                  </div>
                                )}
                                {(isCategoryActive || isSearching) &&
                                  tags?.map(tag => {
                                    const { name, id } = tag;
                                    const active = activeTag && activeTag.id === id && isCategoryActive;
                                    const visible = !isSearching || name.toLowerCase().includes(searchVal.toLowerCase());
                                    if (!visible) return null;
                                    return (
                                      <div
                                        key={id}
                                        onClick={() => this.toggleTag(tag, category)}
                                        className={classnames('row level-four', { active: active })}
                                      >
                                        <div className='main'>{name}</div>
                                      </div>
                                    );
                                  })}
                              </Fragment>
                            );
                          })}
                      </Fragment>
                    );
                  })}
              </div>
            );
          })}
        <Fragment>
          {!isSearching && (
            <div onClick={() => this.setState({ displayingBrands: !displayingBrands })} className={classnames('row', { active: displayingBrands })}>
              <div className='main'>Brands</div>
            </div>
          )}
        </Fragment>
        {(displayingBrands || isSearching) &&
          allBrands.map(brand => {
            const { id, name, domain } = brand;
            const active = activeAllBrand_id === id;
            const visible =
              !isSearching ||
              (name && name.toLowerCase().includes(searchVal.toLowerCase())) ||
              (domain && domain.toLowerCase().includes(searchVal.toLowerCase()));
            if (!visible) return null;
            return (
              <div key={id} onClick={() => this.toggleBrand(brand, null)} className={classnames('row level-two', { active: active })}>
                <div className='main lower'>{isSearching ? `${name || domain} in All` : name || domain}</div>
              </div>
            );
          })}
      </div>
    );
  }
}

export default ProductCatalogHierarchyView;
